import { render, staticRenderFns } from "./AddChannelStage2.vue?vue&type=template&id=e145f2dc&scoped=true"
import script from "./AddChannelStage2.vue?vue&type=script&lang=js"
export * from "./AddChannelStage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e145f2dc",
  null
  
)

export default component.exports